import { AutogenLayoutCustomersWithoutActivityReport } from "./autogen/AutogenLayoutCustomersWithoutActivityReport";

export class CustomersWithoutActivityReport extends AutogenLayoutCustomersWithoutActivityReport {
    override onLoad(): void {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }

    groupByChanged() {
        const groupBy = this.textboxGroupBy.text;
        if (groupBy?.startsWith("None")) {
            this.switchPageBreak.enabled = false;
            this.switchPageBreak.checked = false;
            this.switchPageBreak.caption = "Page Break";
        } else if (groupBy?.startsWith("Salesperson")) {
            this.switchPageBreak.enabled = true;
            this.switchPageBreak.checked = false;
            this.switchPageBreak.caption = "Page Break After Each Salesperson";
        } else if (groupBy?.startsWith("Collections")) {
            this.switchPageBreak.enabled = true;
            this.switchPageBreak.checked = false;
            this.switchPageBreak.caption = "Page Break After Each Collection User";
        } else if (groupBy?.startsWith("Operations")) {
            this.switchPageBreak.enabled = true;
            this.switchPageBreak.checked = false;
            this.switchPageBreak.caption = "Page Break After Each Operations User";
        }

    }

}
